export default {
    calls:            'Звонки',
    close:            'Закрыть',
    comment:          'Комментарий',
    forms:            'Заявки',
    nextPage:         'Следующая страница',
    pagination:       'Пагинация',
    playbackPosition: 'Позиция воспроизведения',
    previousPage:     'Предыдущая страница',
    send:             'Отправить',
};
